import { render } from "./usuarios.vue?vue&type=template&id=edddfda4&scoped=true"
import script from "./usuarios.vue?vue&type=script&lang=js"
export * from "./usuarios.vue?vue&type=script&lang=js"

import "./usuarios.vue?vue&type=style&index=0&id=edddfda4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edddfda4"]])

export default __exports__